module.exports = __webpack_public_path__ + "img/mk-bg-02.3b0aaa8d.png";